import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadComponent: () => import('./features/auth/components/login/login.component').then(m => m.LoginComponent)
  },
  // Registration disabled
  // {
  //   path: 'register',
  //   loadComponent: () => import('./features/auth/components/register/register.component').then(m => m.RegisterComponent)
  // },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  {
    path: 'users',
    canActivate: [authGuard, roleGuard('TOOL_ADMIN_USERS')],
    loadComponent: () => import('./pages/users/users.component').then(m => m.UsersComponent)
  },
  {
    path: 'dmd',
    canActivate: [authGuard, roleGuard('TOOL_ADMIN_DMD')],
    loadComponent: () => import('./pages/dmd/dmd.component').then(m => m.DmdComponent)
  },
  {
    path: 'files',
    canActivate: [authGuard, roleGuard('TOOL_ADMIN_FILES')],
    loadComponent: () => import('./pages/files/files.component').then(m => m.FilesComponent)
  },
  {
    path: 'eds-extraction',
    canActivate: [authGuard, roleGuard('TOOL_ADMIN_DMD')],
    loadComponent: () => import('./pages/eds-extraction/eds-extraction.component').then(m => m.EdsExtractionComponent)
  },
  {
    path: 'data-analysis',
    canActivate: [authGuard, roleGuard('TOOL_ADMIN')],
    loadComponent: () => import('./pages/data-analysis/data-analysis.component').then(m => m.DataAnalysisComponent)
  },
  {
    path: 'yearly-tables',
    canActivate: [authGuard, roleGuard('TOOL_ADMIN_YEARLY_TABLES')],
    loadComponent: () => import('./pages/yearly-tables/yearly-tables.component').then(m => m.YearlyTablesComponent)
  },
  {
    path: '**',
    redirectTo: '/dashboard'
  }
];
